import { configureStore } from "@reduxjs/toolkit";
import bookingReducer from "../features/bookings/booking/bookingsSlice";
import carAvailabilityReducer from "../features/bookings/carAvailability/carAvailabilitySlice";
import carsReducer from "../features/dashboard/ManageCars/carsSlice";
import blackoutDatesReducer from "../features/dashboard/ManageBookings/Blackout/BlackoutSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const bookingPersistConfig = {
  key: "bookings",
  storage,
  whitelist: ["email", "cellphone", "country", "name", "totalPrice"], // specify which reducer(s) you want to persist
};

const carAvailabilityPersistConfig = {
  key: "carAvailability",
  storage,
  whitelist: ["date", "session", "people"], // specify which reducer(s) you want to persist
};
const rootReducer = {
  bookings: persistReducer(bookingPersistConfig, bookingReducer),
  carAvailability: persistReducer(
    carAvailabilityPersistConfig,
    carAvailabilityReducer
  ),
  cars: carsReducer,
  blackoutDates: blackoutDatesReducer,
};

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV === "production",
});

export const persistor = persistStore(store);
